import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { apiForgotPassword } from "@/lib/api";
import { SEO } from "@/components/SEO";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const SENT_MSG = "Se esiste un account associato a questo indirizzo email, riceverai un link per reimpostare la password. Controlla anche la cartella spam.";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const valid = EMAIL_RE.test(email.trim());

  const submit = async (e) => {
    e.preventDefault();
    if (!valid || busy) { setError("Inserisci un indirizzo email valido"); return; }
    setBusy(true); setError("");
    try { await apiForgotPassword(email.trim()); setSent(true); }
    catch (err) { setError(err.status === 429 ? "Troppe richieste. Riprova tra qualche minuto." : "Non è stato possibile inviare la richiesta. Riprova più tardi."); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <SEO title="Recupera la password" />
      <div className="bg-surfaceSecondary border border-hair rounded-2xl p-6 sm:p-8">
        {sent ? (
          <div data-testid="forgot-sent" className="text-center">
            <MailCheck size={36} className="mx-auto text-brand mb-4" />
            <h1 className="font-serif text-2xl font-semibold text-onSurface mb-3">Controlla la tua email</h1>
            <p data-testid="forgot-sent-message" className="text-sm text-onSurfaceSecondary leading-relaxed">{SENT_MSG}</p>
          </div>
        ) : (
          <form onSubmit={submit} noValidate data-testid="forgot-form">
            <h1 className="font-serif text-2xl font-semibold text-onSurface mb-2">Recupera la password</h1>
            <p className="text-sm text-onSurfaceSecondary mb-6">Inserisci l’indirizzo email associato al tuo account. Ti invieremo un link per impostare una nuova password.</p>
            <label className="relative block">
              <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-subtle" />
              <input
                type="email" required autoComplete="email" inputMode="email" value={email} placeholder="La tua email"
                onChange={(e) => { setEmail(e.target.value); setError(""); }} data-testid="forgot-email"
                className="w-full bg-surface border border-hair rounded-full pl-11 pr-4 py-3 text-sm text-onSurface placeholder:text-subtle focus:outline-none focus:border-brand"
              />
            </label>
            {error && <p data-testid="forgot-error" className="text-xs text-bad mt-2">{error}</p>}
            <button type="submit" disabled={busy || !valid} data-testid="forgot-submit"
              className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-brand text-onBrand font-semibold text-sm hover:bg-brandSecondary disabled:opacity-60 transition-colors">
              {busy && <Loader2 size={16} className="animate-spin" />} Invia link di recupero
            </button>
          </form>
        )}
        <Link to="/login" data-testid="forgot-back-login" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-brand hover:underline">
          <ArrowLeft size={15} /> Torna ad Accedi
        </Link>
      </div>
    </div>
  );
}
